// extracted by mini-css-extract-plugin
export default {"icon":"Ln9ZHh216CnsniU6UXup","deleteIcon":"N74TEkkuERasF2Y2Qtuf","itemControl":"MzwXzW_fznmvcywcNXsX"};